import {intentTypes} from "./type";
import {BaseAction} from "../../actions/base";

const types = intentTypes;

const path = `iot/intent`;

const base = new BaseAction(types);

export const getIntentDatas = () => (dispatch) => {
    return base.getDatas(path, dispatch);
};

export const getDeletedIntentDatas = () => (dispatch) => {
    return base.getDatas(`${path}/deleted`, dispatch);
};

export const getIntentData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}`, dispatch);
};

export const getDeletedIntentData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}/deleted`, dispatch);
};

export const addIntentData = (newData) => (dispatch) => {
    return base.addData(path, dispatch, newData);
};

export const editIntentData = (id, newData) => (dispatch) => {
    return base.editData(`${path}/${id}`, dispatch, newData);
};

export const deleteIntentData = (id) => (dispatch) => {
    return base.deleteData(`${path}/${id}`, dispatch, id);
};

export const restoreIntentData = (id) => (dispatch) => {
    return base.restoreData(`${path}/${id}/restore`, dispatch, id);
};

export const hardDeleteIntentData = (id) => (dispatch) => {
    return base.hardDeleteData(`${path}/${id}/confirmdelete`, dispatch, id);
};
